// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/*
 * Override react-responsive-carousel's legend (caption) opacity for carousels
 * that opt in via the .hideIdleLegend wrapper: fully hidden when idle instead
 * of the package's faint 0.25, still fading in to 1 on hover. Scoped through
 * the wrapper so these win on specificity, NOT source order — this stylesheet
 * loads before the package's, so an equal-specificity rule would lose the tie.
 */
.hideIdleLegend .carousel .slide .legend {
  opacity: 0;
}

.hideIdleLegend .carousel:hover .slide .legend {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;;;;;;EAME;AACF;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/*\n * Override react-responsive-carousel's legend (caption) opacity for carousels\n * that opt in via the .hideIdleLegend wrapper: fully hidden when idle instead\n * of the package's faint 0.25, still fading in to 1 on hover. Scoped through\n * the wrapper so these win on specificity, NOT source order — this stylesheet\n * loads before the package's, so an equal-specificity rule would lose the tie.\n */\n.hideIdleLegend .carousel .slide .legend {\n  opacity: 0;\n}\n\n.hideIdleLegend .carousel:hover .slide .legend {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
